module.exports = __webpack_public_path__ + "img/teacher-bg.2a393530.png";